import React from 'react';
import Dashnav from '../Components/Dashnav';
import Leftmenu from '../Components/Leftmenu';
import AdmissionStepsComp from './AdmissionStepsComp';

function AdmissionSteps() {
  return (
    <div>
      <div className='mainContainer'>
        <Leftmenu />
        <div className='theMainContainer'>
          <Dashnav />
          <AdmissionStepsComp />
        </div>
      </div>
    </div>
  );
}

export default AdmissionSteps;
